const getTriggerStepTemplate = ({ timeMachine, step }) => {
  const stepEntry = {
    firstTime: 0,
    indent: 0,
    lastIndex: 0,
    lastOutput: {
      children: [],
      response: step.response,
      stepId: step?.stepId
    },
    searchableData: [{ data: step?.response?.data, time: 0, message: step?.message }],
    stepId: step?.stepId,
    trigger: true
  };
  const timeMachineEntry = { index: timeMachine.length, stepId: step?.stepId, step, siblings: 0, children: 0 };
  return { stepEntry, timeMachineEntry };
};

const getManualTriggerStepTemplate = ({ timeMachine, manualUser, manualUserId }) => {
  const message = manualUser?.name && manualUser?.email ? `Ran manually by ${manualUser.name}` : `Ran manually by user ${manualUserId}`;

  const responseData = [{ name: manualUser?.name || 'Unknown User', email: manualUser?.email || null }];

  const step = {
    stepId: 'manual-trigger',
    message,
    response: { data: responseData, success: true }
  };

  const stepEntry = {
    firstTime: 0,
    indent: 0,
    lastIndex: 0,
    lastOutput: { children: [], response: step.response, stepId: step?.stepId },
    searchableData: [{ data: step?.response?.data, time: 0, message }],
    stepId: step?.stepId,
    trigger: true,
    icon: 'FiUser'
  };
  const timeMachineEntry = { index: timeMachine.length, stepId: step?.stepId, step, siblings: 0, children: 0 };
  return { stepEntry, timeMachineEntry };
};

const getFunctionTriggerStepTemplate = ({ timeMachine, step }) => {
  const message = `Ran from workflow${step?.workflowName ? ` ${step?.workflowName}` : ''}`;
  const responseData = [
    {
      stepId: 'function-trigger',
      appSlug: step?.appSlug,
      message,
      workflowName: step?.workflowName,
      isSynchronousWebhook: step?.isSynchronousWebhook || false
    }
  ];

  const stepWithResponse = {
    ...step,
    message,
    response: step?.response || { data: responseData, success: true }
  };

  const stepEntry = {
    firstTime: 0,
    indent: 0,
    lastIndex: 0,
    lastOutput: { children: [], response: stepWithResponse.response, stepId: step?.stepId },
    searchableData: [{ data: stepWithResponse.response?.data, time: 0, message }],
    stepId: 'function-trigger',
    trigger: true
  };
  const timeMachineEntry = { index: timeMachine.length, stepId: 'function-trigger', step: stepWithResponse, siblings: 0, children: 0 };
  return { stepEntry, timeMachineEntry };
};

const getIncompleteWorkflowStepTemplate = ({ allSteps, timeMachine }) => {
  const stepEntry = {
    firstTime: allSteps.length,
    indent: 0,
    lastIndex: allSteps.length,
    lastOutput: {
      children: [],
      response: { data: [], meta: { code: 'INCOMPLETE_WORKFLOW' } },
      stepId: 'incomplete-workflow'
    },
    stepId: 'incomplete-workflow'
  };
  const timeMachineEntry = { index: timeMachine.length, stepId: 'incomplete-workflow', step: { stepId: 'incomplete-workflow' }, siblings: 0, children: 0 };
  return { stepEntry, timeMachineEntry };
};
export { getTriggerStepTemplate, getIncompleteWorkflowStepTemplate, getManualTriggerStepTemplate, getFunctionTriggerStepTemplate };
